import { render } from "./DashboardViewPage.vue?vue&type=template&id=7550d123&scoped=true"
import script from "./DashboardViewPage.vue?vue&type=script&lang=js"
export * from "./DashboardViewPage.vue?vue&type=script&lang=js"

import "./DashboardViewPage.vue?vue&type=style&index=0&id=7550d123&scoped=true&lang=css"

import exportComponent from "/usr/app/workspace-stack/frontend-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7550d123"]])

export default __exports__